import {
    GET_ALL_NEWS_SUCCEEDED,
    GET_LAST_NEWS_FROM_ALL_CATEGORIES_SUCCEEDED,
    GET_LAST_NEWS_SUCCEEDED,
    GET_NEWS_DETAILS_SUCCEEDED,
    GET_SLIDER_NEWS_SUCCEEDED,
    GET_NEWS_FROM_CATEGORY_SUCCEEDED,
    GET_NEWS_FROM_CATEGORY_SEE_MORE_SUCCEEDED,
    GET_RECOMMENDED_NEWS_SUCCEEDED, GET_NEWS_CATEGORIES_SUCCEEDED
} from '../actions/types';

const initialState = {
    allNews: [],
    lastNews: [],
    newsFromCategs: [],
    newsDetails: {},
    sliderNews: [],
    newsCateg: [],
    recommendedNews: [],
    newsCategories: []
};

export default function(state = initialState, action) {
    switch(action.type) {
        case GET_ALL_NEWS_SUCCEEDED:
            return {
                ...state,
                allNews: action.payload
            };
        case GET_SLIDER_NEWS_SUCCEEDED:
            return {
                ...state,
                sliderNews: action.payload.rows
            };
        case GET_LAST_NEWS_SUCCEEDED:
            return {
                ...state,
                lastNews: action.payload
            };
        case GET_LAST_NEWS_FROM_ALL_CATEGORIES_SUCCEEDED:
            return {
                ...state,
                newsFromCategs: action.payload
            };
        case GET_NEWS_DETAILS_SUCCEEDED:
            return {
                ...state,
                newsDetails: action.payload
            } 
        case GET_NEWS_FROM_CATEGORY_SUCCEEDED:
            return {
                ...state,
                newsCateg: action.payload
            }
        case GET_NEWS_FROM_CATEGORY_SEE_MORE_SUCCEEDED:
            return {
                ...state,
                newsCateg: action.payload
            }
        case GET_RECOMMENDED_NEWS_SUCCEEDED:
            return {
                ...state,
                recommendedNews: action.payload
            }
        case GET_NEWS_CATEGORIES_SUCCEEDED:
            return {
                ...state,
                newsCategories: action.payload
            }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/SHARED/reducers/news.reducer.js